<template>
  <div class="condition-item">
    <div class="condition-item_top" :class="data.expend ? 'is-expended' : ''">
      <div class="condition-item__arrow">
        <i class="yxt-icon-arrow-right hand" :class="{'is-active': data.expend}" @click="data.expend=!data.expend"></i>
        <label class="font-bolder color-gray-10">{{title}}</label>
      </div>
      <div class="condition-item__del">
        <yxt-button
          type="text"
          class="yxt-color-danger"
          @click="onConditionDel"
          >{{ $t('pc_biz_rule_lbl_delete' /* '删除' */) }}</yxt-button>
      </div>
    </div>
    <div class="condition-item_panel" :class="data.expend ? 'is-expended' : ''">
      <div class="condition-form">
        <yxt-form
          ref="cndForm"
          :model="data"
          :rules="formRules"
          label-width="80px"
        >
          <yxt-form-item class="inline-block" :label="$t('pc_biz_rule_module_request' /* 模块要求 */)" prop="targetCode">
            <yxt-select
              class="mr32"
              v-model="data.targetCode"
              :placeholder="commonSelectPlaceholder"
              clearable
              @change="changeObject"
              @clear="handleObjectClear"
            >
              <yxt-option
                v-for="item in objList"
                :key="item.targetCode"
                :label="item.targetName"
                :value="item.targetCode"
              >
              </yxt-option>
            </yxt-select>
            <yxt-select
              v-if="objectChildrenList.length > 0"
              v-model="data.moduleCode"
              class="mr32"
              :placeholder="commonSelectPlaceholder"
              clearable
              @change="changeChildObject"
              @clear="handleObjectChildClear"
            >
              <yxt-option
                v-for="item in objectChildrenList"
                :key="item.targetCode"
                :label="item.targetName"
                :value="item.targetCode"
              >
              </yxt-option>
            </yxt-select>
          </yxt-form-item>
          <yxt-form-item class="inline-block" :label="$t('pc_biz_rule_trigger_action' /* 触发动作 */ )" prop="actionCode">
            <yxt-select
              v-model="data.actionCode"
              :placeholder="commonSelectPlaceholder"
              clearable
              @change="changeAction"
              @clear="handleActionClear"
            >
              <yxt-option
                v-for="item in actionList"
                :key="item.actionCode"
                :label="item.actionName"
                :value="item.actionCode"
              >
              </yxt-option>
            </yxt-select>
          </yxt-form-item>
          <yxt-form-item
            class="special-item"
            inline-message
            :label="$t('pc_biz_rule_specific_request' /* 具体要求 */)"
            prop="listConditionAttr"
          >
          </yxt-form-item>
          <!-- <yxt-form
            ref="attrForm"
            :model="data.listConditionAttr"
            label-width="0px"
            class="attr-form"
          > -->
            <yxt-table
              class="attr-table"
              :data="data.listConditionAttr"
            >
              <yxt-table-column
                :label="$t('pc_biz_rule_index' /* 序号 */)"
                type="index"
                width="60px"
                align="center" />
              <yxt-table-column
                :label="$t('pc_biz_rule_specific_request' /*具体要求*/)"
                prop="attrCode"
                min-width="200px"
              >
                <template slot-scope="scope">
                  <yxt-form-item
                    label-width="0px"
                    :prop="`listConditionAttr.${scope.$index}.attrCode`"
                    :rules="[{ required: true, message: $t('pc_biz_rule_please_select_attr' /* '请选择具体要求' */), trigger: ['blur', 'change'] }]"
                  >
                    <yxt-select
                      class="width185"
                      v-model="scope.row.attrCode"
                      :placeholder="commonSelectPlaceholder"
                      @change="val => changeAttr(val, scope.row)"
                    >
                      <yxt-option
                        v-for="(item, index) in getRowAttrList(scope.row.attrCode)"
                        :key="`${index}${item.attrCode}`"
                        :label="item.attrName"
                        :value="item.attrCode"
                      >
                      </yxt-option>
                    </yxt-select>
                  </yxt-form-item>
                </template>
              </yxt-table-column>
              <yxt-table-column
                :label="$t('pc_biz_rule_relation' /*关系*/)"
                prop="attrRelation"
                min-width="200px"
              >
                <template v-if="scope.row.currentAttr" slot-scope="scope">
                  <yxt-form-item
                    label-width="0px"
                    :prop="`listConditionAttr.${scope.$index}.attrRelation`"
                    :rules="[{ required: true, message: $t('pc_biz_rule_please_select_relation' /* '请选择关系' */), trigger: ['blur', 'change'] }]"
                  >
                    <yxt-select
                      class="width185"
                      v-model="scope.row.attrRelation"
                      :placeholder="commonSelectPlaceholder"
                    >
                      <yxt-option
                        v-for="item in scope.row.currentAttr.relationList"
                        :key="`rel${scope.$index}${item.relationType}`"
                        :label="item.relationName"
                        :value="item.relationType"
                      >
                      </yxt-option>
                    </yxt-select>
                  </yxt-form-item>
                </template>
              </yxt-table-column>
              <yxt-table-column
                :label="$t('pc_biz_rule_value' /*值*/)"
                min-width="280px"
              >
                <template v-if="scope.row.currentAttr" slot-scope="scope">
                  <!-- 根据属性判断是使用输入框还是选择框或者日期框 -->
                  <!-- 下拉选择 -->
                  <yxt-form-item
                    v-if="scope.row.currentAttr.attrStyle === 2"
                    label-width="0px"
                    class="inline-block"
                    :prop="`listConditionAttr.${scope.$index}.attrValue`"
                    :rules="[{ required: true, message: $t('pc_biz_rule_pleae_enter' /* '请输入值' */), trigger: ['blur', 'change'] }]"
                  >
                    <yxt-select
                      class="width260"
                      v-model="scope.row.attrValue"
                      :placeholder="commonSelectPlaceholder"
                    >
                      <yxt-option
                        v-for="item in scope.row.currentAttr.datas"
                        :key="item.attrValueCode"
                        :label="item.attrValueName"
                        :value="item.attrValueCode"
                      >
                      </yxt-option>
                    </yxt-select>
                  </yxt-form-item>
                  <!-- 日期选择 -->
                  <yxt-form-item
                    v-else-if="scope.row.currentAttr.attrStyle === 3"
                    label-width="0px"
                    class="inline-block"
                    :prop="`listConditionAttr.${scope.$index}.attrValue`"
                    :rules="[{ required: true, message: $t('pc_biz_rule_please_select_date' /*'请选择日期'*/), trigger: ['blur', 'change'] }]"
                  >
                    <yxt-date-picker
                      v-model="scope.row.attrValue"
                      :type="scope.row.attrRelation === 9 ? 'daterange' : 'date'"
                      value-format="yyyy-MM-dd"
                      :placeholder="$t('pc_biz_rule_select_date' /*选择日期*/)"
                    >
                    </yxt-date-picker>
                  </yxt-form-item>
                  <!-- 输入框 -->
                  <template v-else>
                    <!-- 数值输入框 -->
                    <template v-if="scope.row.currentAttr.attrInputType === 2">
                      <yxt-form-item
                        label-width="0px"
                        class="inline-block"
                        :prop="`listConditionAttr.${scope.$index}.attrValue`"
                        :rules="[{ required: true, message: $t('pc_biz_rule_pleae_enter' /* '请输入值' */), trigger: ['blur', 'change'] }]"
                      >
                        <yxt-input-number
                          v-model="scope.row.attrValue"
                          class="width120"
                          :min="0"
                          :max="999"
                          :precision="2"
                        ></yxt-input-number>
                      </yxt-form-item>
                      <template v-if="scope.row.attrRelation === 9">
                        <span class="mh8">-</span>
                        <yxt-form-item
                          label-width="0px"
                          class="inline-block"
                          :prop="`listConditionAttr.${scope.$index}.maxAttrValue`"
                          :rules="[{ required: true, message: $t('pc_biz_rule_pleae_enter' /* '请输入值' */), trigger: ['blur', 'change'] }]"
                        >
                          <yxt-input-number
                            v-model="scope.row.maxAttrValue"
                            class="width120"
                            :min="0"
                            :max="999"
                            :precision="2"
                          ></yxt-input-number>
                        </yxt-form-item>
                      </template>
                      <!-- 数值输入框单位 -->
                      <span class="ml8">{{ attrQuantityUnitType[scope.row.currentAttr.attrInputNumunitType] }}</span>
                    </template>
                    <!-- 普通输入框 -->
                    <yxt-form-item
                      v-else
                      label-width="0px"
                      class="inline-block"
                      :prop="`listConditionAttr.${scope.$index}.attrValue`"
                      :rules="[{ required: true, message: $t('pc_biz_rule_pleae_enter' /* '请输入值' */), trigger: ['blur', 'change'] }]"
                    >
                      <yxt-input class="width260" v-model="scope.row.attrValue" :placeholder="commonInputPlaceholder" />
                    </yxt-form-item>
                  </template>
                </template>
              </yxt-table-column>
              <yxt-table-column
                :label="$t('pc_biz_rule_operation' /*操作*/)"
                width="70px"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <yxt-button
                    type="text"
                    @click="delAttr(scope.$index)"
                  >
                    {{ $t('pc_biz_rule_lbl_delete' /* '删除' */) }}
                    <!-- <i class="yxt-icon-delete"></i> -->
                  </yxt-button>
                </template>
              </yxt-table-column>
            </yxt-table>
          <!-- </yxt-form> -->
          <div class="custom-rule mt16">
            <div>
              <yxt-button
                plain
                size='large'
                class="custom-btn"
                :disabled="!data.listConditionAttr.length || data.listConditionAttr.length >= 10"
                @click="addAttr"
              >
                <i class="mr10 yxt-icon-plus"></i>{{ $t('pc_biz_rule_btn_add_request'/*'添加要求'*/)}}
              </yxt-button>
              <label class="ml16 color-gray-7">{{ $t('pc_biz_rule_max_add_request' /*'最多添加{0}/{1}条'*/, [attrCount, 10]) }}</label>
            </div>
            <div v-if="customRequestRule" class="condition-wrap__ruler">
              <div class="customize-switch">
                <yxt-switch v-model="data.attrExpressionStatus" />
                <label class="ml16">{{ $t('pc_biz_lbl_request_run_rule' /*'具体要求运算规则'*/) }}</label>
              </div>
              <!-- 自定义运算规则开启 -->
              <div v-if="data.attrExpressionStatus" class="ruler-set mt16">
                <yxt-radio-group
                  v-model="data.anyNumberAttrSwitch"
                  :direction="'row'"
                  class="width-percent-100"
                  @change="onTypeChange"
                >
                  <yxt-radio class="imp-width160" :label="1">
                    <span>{{ $t('pc_biz_rule_reach_any', [1]) /* 达到任意1个要求 */}}</span>
                    <!-- <span class="mr14">{{ $t('pc_biz_reach_any' /*'达到任意'*/) }}</span>
                    <yxt-form-item prop="anyNumberAttr" label-width="0px" class="is-special">
                      <yxt-input-number
                        class="mr8"
                        v-model="data.anyNumberAttr"
                        :precision="0"
                        :min="1"
                        :max="data.listConditionAttr.length || 1"></yxt-input-number>
                    </yxt-form-item>
                    <span>{{ $t('pc_biz_lbl_requests'/*'个要求')*/) }}</span> -->
                  </yxt-radio>
                  <yxt-radio :label="0">
                    <span>{{ $t('pc_biz_rule_custom' /*'自定义'*/) }}</span>
                    <yxt-tooltip effect="light" placement="right">
                      <div class="customize-tooltip" slot="content" v-html="$t('pc_biz_rule_request_remark')">
                        <!-- <p class="rule-remark">自定义：适用于复杂规则的编辑，当多个具体条件部分需要满足或指定条件满足时可使用该编辑器</p>
                        <p class="example-title">举例</p>
                        <p>具体要求1：入职时间小于1年</p>
                        <p>具体要求2：学时大于100分钟</p>
                        <p>具体要求3：积分大于50</p>
                        <p>若想达到：新学员（入职小于1年）学时>100分钟或者新学员积分>50的条件，可输入：<span class="rule-equation">1and(2or3)</span></p>
                        <p class="rule-character-remark">数字即具体条件的编号；and表示“且”的关系，即都需要满足；or表示“或”的关系，即任一满足；</p>
                        <p class="rule-character-remark">表达式规范：只能使用数字、英文括号、and 和 or，不能有重复数字 ()——左括号和右括号必须成对出现，不区分大小写</p> -->
                      </div>
                      <yxt-svg class="ml4 mr8" width="16px" height="16px" icon-class="question-cirlce-o" />
                    </yxt-tooltip>
                    <yxt-form-item prop="attrExpression" label-width="0px" class="is-special custom-rule-width">
                      <yxt-input
                        v-model="data.attrExpression"
                        :disabled="!!data.anyNumberAttrSwitch"
                        class="customize-input"
                        :placeholder="commonInputPlaceholder"
                        maxlength="100"
                        show-word-limit
                      />
                    </yxt-form-item>
                  </yxt-radio>
                </yxt-radio-group>
              </div>
            </div>
          </div>
        </yxt-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getRelatedActionList, getRelatedAttrList, checkExpression } from '../service';
// 条件名称枚举
// const numLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
// 数量与被点赞数的互斥前提条件,格式：targetCode;moduleCode;actionCode
const attrMutualLimit = [
  'bbs_post;publish', // 帖子/文章；发布
  'bbs_post;comment', // 帖子/文章；评论
  'bbs_Q&A;publish', // 问答；发布
  'bbs_Q&A;answer', // 问答；回答
  'bbs_Q&A;Q&A_answer;reply' // 问答；问答回答；回复
];
// code枚举
const CODEKEYS = {
  Count: 'count',
  BeLikeCount: 'count_beliked'
};
export default {
  name: 'ConditionItem',
  props: {
    condition: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    },
    // 是否开启自定义规则
    customRequestRule: {
      type: Boolean,
      default: false
    },
    // 使用平台
    platformType: {
      type: String,
      default: ''
    },
    // 模块要求列表
    objList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // const validCustomRuleCount = (rule, value, callback) => {
    //   if (!value && this.data.anyNumberAttrSwitch === 1) {
    //     callback(new Error(this.$t('pc_biz_rule_please_enter_conditon_count' /* '请输入达到任意要求的个数' */)));
    //   }
    //   callback();
    // };
    const validCustomRule = async(rule, value, callback) => {
      if (this.data.attrExpressionStatus && this.data.anyNumberAttrSwitch === 0) {
        if (!value) {
          callback(new Error(this.$t('pc_biz_rule_please_enter_rule' /* '请输入自定义规则' */)));
        }
        const result = await checkExpression({expression: value, maxSort: this.attrCount }, this.platformType);
        if (!result) {
          callback(new Error(this.$t('pc_biz_rule_expression_error' /* '表达式错误' */)));
        }
      }
      callback();
    };
    return {
      data: {
        targetCode: '',
        actionCode: '',
        moduleCode: '',
        listConditionAttr: [],
        anyNumberAttrSwitch: 0, // 任意N个属性开关，0：未开启，1：开启
        anyNumberAttr: 1, // 任意N个属性值
        attrExpressionStatus: false, // 属性规则表达式状态 1:打开 0:关闭
        attrExpression: '' // 属性表达式
      },
      formRules: {
        targetCode: [{ required: true, message: this.$t('pc_biz_rule_please_select_module' /* '请选择模块要求' */), trigger: ['blur', 'change'] }],
        actionCode: [{ required: true, message: this.$t('pc_biz_rule_please_select_action' /* '请选择触发动作' */), trigger: ['blur', 'change'] }],
        listConditionAttr: [
          { required: true, message: this.$t('pc_biz_rule_please_add_attr' /* '请添加具体要求' */), trigger: ['blur', 'change'] }
          // { validator: validAttrItem, trigger: ['blur', 'change'] }
        ],
        // 后期释放
        // anyNumberAttr: [{ validator: validCustomRuleCount.bind(this), trigger: 'blur' }],
        attrExpression: [
          { validator: validCustomRule.bind(this), trigger: ['blur'] }
        ]
      },
      objectChildrenList: [],
      actionList: [],
      // 动作关联的原始属性集合
      relatedAttrList: [],
      // 数值输入框属性单位类型
      attrQuantityUnitType: {
        1: this.$t('pc_biz_rule_unit_count' /* '个' */),
        2: this.$t('pc_biz_rule_unit_m' /* '分'*/),
        3: '%',
        4: this.$t('pc_biz_rule_unit_day' /* '天'*/)
      },
      commonSelectPlaceholder: this.$t('pc_biz_rule_select_placeholder' /* 请选择 */),
      commonInputPlaceholder: this.$t('pc_biz_rule_input_placeholder' /* 请输入 */)
    };
  },
  watch: {
    'condition': {
      handler(val) {
        if (val && val.targetCode) {
          // 有值，且已选择了模块要求
          this.init(val);
        } else {
          this.data = val;
        }
      },
      immediate: true
    }
  },
  computed: {
    title() {
      return this.$t('pc_biz_rule_condition_name' /* '条件'*/, [this.index + 1]);
    },
    // 具体要求数量
    attrCount() {
      return this.data && this.data.listConditionAttr ? this.data.listConditionAttr.length : 0;
    },
    // 已设置的属性code集合
    usedAttrCodeList() {
      return this.data.listConditionAttr ? this.data.listConditionAttr.map(i => i.attrCode) : [];
    },
    needCountMutex() {
      const compareStr = `${this.data.targetCode};${this.data.moduleCode ? this.data.moduleCode + ';' : ''}${this.data.actionCode}`;
      return attrMutualLimit.includes(compareStr);
    },
    // "数量"属性被使用
    usedAttrCount() {
      return this.usedAttrCodeList.includes(CODEKEYS.Count);
    },
    // "被点赞数"属性被使用
    usedAttrBelikedCount() {
      return this.usedAttrCodeList.includes(CODEKEYS.BeLikeCount);
    }
  },
  methods: {
    // 获取每行具体要求可选的要求集合
    getRowAttrList(code) {
      let baseList = this.relatedAttrList.filter(i => !this.usedAttrCodeList.includes(i.attrCode) || code === i.attrCode);
      if (this.needCountMutex) {
        // 满足数量、被点赞数互斥的前提条件
        if (this.usedAttrCount && code !== CODEKEYS.Count) {
          // 数量属性被使用，且当前选中值是数量属性，排除“被点赞数”属性
          baseList = baseList.filter(i => i.attrCode !== CODEKEYS.BeLikeCount);
        } else if (this.usedAttrBelikedCount && code !== CODEKEYS.BeLikeCount) {
          // 被点赞数属性被使用，且当前选中值是被点赞数属性，排除“数量”属性
          baseList = baseList.filter(i => i.attrCode !== CODEKEYS.Count);
        }
      }
      return baseList;
    },
    init(val) {
      // 基础数据
      this.data = {
        ...val,
        attrExpressionStatus: !!val.attrExpressionStatus
      };
      // 模块要求
      if (!this.objList.length) return;
      const _object = this.objList.find(
        t => t.targetCode === this.data.targetCode
      );
      this.objectChildrenList = _object && _object.childList ? _object.childList : [];
      // 子模块
      this.data.moduleCode = val.moduleCode;
      // 触发动作
      let _targetCode = this.data.targetCode;
      if (this.data.moduleCode) {
        _targetCode = this.data.moduleCode;
      }
      this.fetchAction(_targetCode).then(() => {
        this.data.actionCode = val.actionCode;
        // 具体要求（属性）
        this.fetchAttr(this.data.actionCode, true).then(() => {
          this.data.listConditionAttr = val.listConditionAttr.map((attr, sidx) => {
            const _currentAttr = this.relatedAttrList.find(
              ra => ra.attrCode === attr.attrCode
            );
            let _attrValue = null;
            if (_currentAttr && _currentAttr.attrStyle === 3 && attr.attrRelation === 9) {
              // 双日期输入框
              _attrValue = [attr.attrValue, attr.maxAttrValue];
            } else {
              _attrValue = attr.attrValue;
            }
            return {
              attrCode: attr.attrCode,
              attrRelation: +attr.attrRelation,
              attrValue: _attrValue,
              // 用于属性-数值，关系-介于
              maxAttrValue: attr.maxAttrValue,
              id: attr.id,
              deleted: 0,
              sort: sidx + 1,
              currentAttr: _currentAttr
            };
          });
        });
      });
    },
    /**
     * 删除条件
     */
    onConditionDel() {
      this.$emit('delete', this.index);
    },
    /**
     * 初始化动作
     */
    fetchAction(targetCode) {
      let _object = this.objList && this.objList.find(i => i.targetCode === targetCode);
      if (!_object && this.objectChildrenList && this.objectChildrenList.length) {
        _object = this.objectChildrenList.find(i => i.targetCode === targetCode);
      }
      const associateId = _object && _object.associateId;
      if (!associateId) {
        this.$error(this.$t('pc_biz_rule_msg_lost_base_data' /* '请前往规则属性管理，检查补充对象/动作/属性等信息'*/));
        return;
      }
      return getRelatedActionList(associateId, this.platformType).then(res => {
        this.actionList = res;
      });
    },
    /**
     * 初始化属性
     */
    fetchAttr(actionCode, isInit) {
      const _action = this.actionList && this.actionList.find(i => i.actionCode === actionCode);
      const associateId = _action && _action.associateId;
      if (!associateId) {
        this.$error(this.$t('pc_biz_rule_msg_lost_base_data' /* '请前往规则属性管理，检查补充对象/动作/属性等信息'*/));
        return;
      }
      return getRelatedAttrList(associateId, this.platformType).then(res => {
        this.relatedAttrList = res;
        if (this.relatedAttrList.length && !isInit) {
          this.addAttr();
        }
      });
    },
    /**
     * 添加属性
     */
    addAttr() {
      const row = {
        attrCode: null,
        attrRelation: null,
        attrValue: null,
        maxAttrValue: null,
        currentAttr: null
      };
      this.data.listConditionAttr.push(row);
      this.$refs.cndForm.clearValidate('listConditionAttr');
    },
    /**
     * 删除属性
     */
    delAttr(index) {
      if (this.attrCount === 1) {
        this.$message.warning(this.$t('pc_biz_msg_at_least_one_request' /* '请至少保留一个具体要求'*/));
        return;
      }
      this.data.listConditionAttr.splice(index, 1);
    },
    /**
     * 变更模块要求
     */
    changeObject(e) {
      if (!e) return;
      this.data.targetCode = e;
      this.data.moduleCode = '';
      this.data.actionCode = '';
      this.data.listConditionAttr = [];
      const _object = this.objList.find(o => o.targetCode === e);
      this.objectChildrenList = _object && _object.childList ? _object.childList : [];
      this.fetchAction(this.data.targetCode);
    },
    /**
     * 清空模块要求
     */
    handleObjectClear() {
      this.data.targetCode = '';
      this.data.actionCode = '';
      this.data.moduleCode = '';
      this.objectChildrenList = [];
      this.actionList = [];
      this.data.listConditionAttr = [];
    },
    /**
     * 清空子模块要求
     */
    handleObjectChildClear() {
      this.data.moduleCode = '';
      this.data.actionCode = '';
      this.data.listConditionAttr = [];
      if (this.data.targetCode) {
        this.fetchAction(this.data.targetCode);
      }
    },
    /**
     * 变更子模块要求
     */
    changeChildObject(e) {
      if (!e) return;
      this.data.moduleCode = e;
      this.data.actionCode = '';
      this.data.listConditionAttr = [];
      this.fetchAction(this.data.moduleCode);
    },
    /**
     * 变更触发动作
     */
    changeAction(e) {
      if (!e) return;
      this.data.actionCode = e;
      this.data.listConditionAttr = [];
      this.fetchAttr(this.data.actionCode);
    },
    /**
     * 清空触发动作
     */
    handleActionClear() {
      this.data.actionCode = '';
      this.data.listConditionAttr = [];
    },
    /**
     * @desc    选择属性改变,根据选中的属性获取对应的关系集合,如果属性值是选择项,还需要获取选择项的集合
     * @param   {string} code - 当前行属性code
     * @param   {object} item   - 当前行数据
     */
    changeAttr(code, item) {
      const currentAttr = this.relatedAttrList.find(i => i.attrCode === code);
      item = Object.assign(item, {
        currentAttr,
        attrRelation: null,
        attrValue: null,
        maxAttrValue: null
      });
    },
    /**
     * 处理自定义规则方式切换
     */
    onTypeChange(val) {
      if (val) {
        this.data.attrExpression = '';
      }
      this.$refs.cndForm.clearValidate(['anyNumberAttr', 'attrExpression']);
    },
    /**
     * 数据校验
     */
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.cndForm.validate().then(() => {
          resolve(true);
        }).catch(() => {
          reject(new Error(this.$t('pc_biz_rule_please_complete_info' /* '请完善必填项' */)));
        });
        // Promise.all([this.$refs.cndForm.validate(), this.$refs.attrForm.validate()]).then(res => {
        //   resolve(true);
        // }).catch(() => {
        //   reject(new Error(this.$t('pc_biz_rule_please_complete_info' /* '请完善必填项' */)));
        // });
      });
    },
    /**
     * 获取条件数据对象
     */
    getData() {
      return {
        ...this.data,
        attrExpressionStatus: ~~this.data.attrExpressionStatus,
        listConditionAttr: this.data.listConditionAttr.map((item, index) => {
          let attrValue = item.attrValue;
          let maxAttrValue = null;
          if (item.attrRelation === 9) {
            // 双数值
            maxAttrValue = item.maxAttrValue;
            if (typeof (item.attrValue) === 'object') {
              // 时间范围属性
              attrValue = item.attrValue.length > 0 ? item.attrValue[0] : null;
              maxAttrValue = item.attrValue.length > 1 ? item.attrValue[1] : null;
            }
          }
          return {
            ...item,
            attrValue,
            maxAttrValue,
            sort: index + 1
          };
        })
      };
    }
  }
};
</script>
